import axios from 'axios'
import { API_BASE } from '@/core/config'
import { TOKEN_KEY } from '@/core/storage'
import { resolveApiMessage } from '@/core/api/errorMessage'

const http = axios.create({
  baseURL: API_BASE,
  timeout: 60000
})

http.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY)
  const url = config.url || ''
  const isAuthRequest = url.includes('/auth/login')
  if (token && !isAuthRequest) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(
  (response) => {
    const body = response.data
    if (body && typeof body.code === 'number' && body.code !== 0) {
      const err = new Error(resolveApiMessage(body.message))
      err.code = body.code
      err.response = response
      return Promise.reject(err)
    }
    return body?.data !== undefined ? body.data : body
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY)
      const path = window.location.pathname
      if (!path.startsWith('/login')) {
        window.location.href = '/login'
      }
    }
    const rawMsg =
      error.response?.data?.message ||
      error.message ||
      '网络请求失败'
    const msg = resolveApiMessage(rawMsg)
    const err = new Error(msg)
    err.code = error.response?.data?.code
    err.status = error.response?.status
    return Promise.reject(err)
  }
)

export function fileUrl(path) {
  if (!path) return ''
  if (path.startsWith('http') || path.startsWith('data:')) return path
  const base = process.env.VUE_APP_FILE_BASE
  if (base === undefined || base === '') {
    return path.startsWith('/') ? path : `/${path}`
  }
  const root = base.replace(/\/$/, '')
  return `${root}${path.startsWith('/') ? path : `/${path}`}`
}

export default http
